module.exports = __webpack_public_path__ + "static/img/culture.503b7431.png";